import { render, staticRenderFns } from "./documents.revenuedepartment.pnd50to55.vue?vue&type=template&id=81e00a3e&scoped=true"
import script from "./documents.revenuedepartment.pnd50to55.vue?vue&type=script&lang=js"
export * from "./documents.revenuedepartment.pnd50to55.vue?vue&type=script&lang=js"
import style0 from "./documents.revenuedepartment.pnd50to55.vue?vue&type=style&index=0&id=81e00a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e00a3e",
  null
  
)

export default component.exports